/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountryNames } from '../../models/country-names';

export interface ApiCountryCountriesGet$Params {
}

export function apiCountryCountriesGet(http: HttpClient, rootUrl: string, params?: ApiCountryCountriesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CountryNames>> {
  const rb = new RequestBuilder(rootUrl, apiCountryCountriesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CountryNames>;
    })
  );
}

apiCountryCountriesGet.PATH = '/api/country/countries';
